import type { ReactNode } from 'react';

export const symbol_delivery_truck_bolt: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M188-196q-32-36-27-85H98q-13 0-21.5-8.5T68-311q0-13 8.5-21.5T98-341h88q15-18 36.5-28.5T270-380q26 0 47.5 10.5T354-341h198l92-399H302q-13 0-21-8.5t-8-21.5q0-13 8.5-21.5T303-800h378q14 0 23.5 11.5T711-763l-31 133h95q14 0 27 6.5t21 17.5l80 107q8 11 10.5 22.5t.5 24.5l-29 146q-2 11-10.5 18t-19.5 7h-55q5 49-27.5 85T690-160q-50 0-82-36t-27-85H380q5 49-27.5 85T270-160q-50 0-82-36Zm446-234h215l6-33-80-107H666l-32 140Zm10-310-92 399 8-36 84-363ZM140-560H87q-9 0-13.5-7.5T74-583l92-147q3-5 8.5-3.5t5.5 7.5v86h53q9 0 13.5 7.5T246-617l-92 148q-3 5-8.5 3.5T140-473v-87Zm130 340q21 0 35.5-15t14.5-35q0-21-14.5-35.5T270-320q-20 0-35 14.5T220-270q0 20 15 35t35 15Zm420 0q21 0 35.5-15t14.5-35q0-21-14.5-35.5T690-320q-20 0-35 14.5T640-270q0 20 15 35t35 15Z"
		/>
	</svg>
);
